module.exports = __webpack_public_path__ + "static/media/cronos-BN.5857d771.svg";